<template>


  <div class="">

    <div v-if="$store.state.fetchcomplete" class="relative styleheight m-4">

      <div class="overlay absolute z-20 w-1/12 right-0 mr-4 mt-4 cursor-pointer">

        <img v-if="!w1" id="w1" @click="hike('w1')" class="mb-4" src="https://weissenburg.nickschnee.ch/wordpress/wp-content/uploads/2020/02/wandern_leicht_hover.png" alt="">
        <img v-if="w1" id="w1" @click="hike('w1')" class="mb-4" src="https://weissenburg.nickschnee.ch/wordpress/wp-content/uploads/2020/02/wandern_leicht.png" alt="">

        <img v-if="!w2" id="w2" @click="hike('w2')" class="mb-4" src="https://weissenburg.nickschnee.ch/wordpress/wp-content/uploads/2020/02/wandern_mittel_hover.png" alt="">
        <img v-if="w2" id="w2" @click="hike('w2')" class="mb-4" src="https://weissenburg.nickschnee.ch/wordpress/wp-content/uploads/2020/02/wandern_mittel.png" alt="">

        <img v-if="!w3" id="w3" @click="hike('w3')" class="mb-4" src="https://weissenburg.nickschnee.ch/wordpress/wp-content/uploads/2020/02/wandern_schwer_hover.png" alt="">
        <img v-if="w3" id="w3" @click="hike('w3')" class="mb-4" src="https://weissenburg.nickschnee.ch/wordpress/wp-content/uploads/2020/02/wandern_schwer.png" alt="">

      </div>

      <l-map
      id="map"
      class="z-10 rounded-lg"
      :zoom="zoom"
      :center="center"
      :options="{scrollWheelZoom:false}"
      @update:zoom="zoomUpdated"
      >

      <l-tile-layer v-if="$store.state.present" :url="url"> </l-tile-layer>
      <l-tile-layer v-if="!$store.state.present" :url="url_history"> </l-tile-layer>

      <div v-bind:key="index.id" v-for="index in sortMarkers" class="">

        <l-marker :lat-lng="[index.longitude, index.latitude_breitengrad]" @click="popup(index.id)">

          <l-icon v-if="current !== index.id" :icon-size="dynamicSize" :icon-url="index.marker_weiss.url" > </l-icon>
          <l-icon v-else="" :icon-size="dynamicSize" :icon-url="index.marker_blau.url" > </l-icon>

        </l-marker>

      </div>

      <l-polyline
      v-if="w1"
      :lat-lngs="polyline1.latlngs"
      :color="polyline1.color">
    </l-polyline>



  </l-map>

</div>

<p class="text-center text-gray-700 text-sm font-thin">wählen Sie die Symbole auf der Karte, um Infos anzuzeigen.</p>


</div>

</template>

<script>
export default {
  components: {
    'l-map': window.Vue2Leaflet.LMap,
    'l-tile-layer': window.Vue2Leaflet.LTileLayer,
    'l-marker': window.Vue2Leaflet.LMarker,
    'l-icon': window.Vue2Leaflet.LIcon,
    'l-polyline': window.Vue2Leaflet.LPolyline,
  },
  name: 'MapComponent',
  props: {

  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      url_history: 'https://{s}.tile.thunderforest.com/pioneer/{z}/{x}/{y}.png?apikey=a5ac2b51a8c540a9afb909a4662f8981',
      // url satellite: https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
      zoom: 14,
      center: [46.663026, 7.469664],
      bounds: null,
      iconSize: 100,
      polyline1: {
        latlngs: [ [46.659175, 7.4754346], [46.666967, 7.465303] ],
        color: 'white'
      },
      sortedMarkers: [],
      current: 'bahnhof',
      w1: false,
      w2: false,
      w3: false,

    }
  },
  methods: {

    zoomUpdated (zoom) {
      this.zoom = zoom;
    },

    popup(current){

      // console.log("clicked!" + current);
      this.current = current;

      this.$store.commit('updatecurrent', current);

    },

    hike(hike){

      if (hike == 'w1'){

        this.w1 = !this.w1

      } else if (hike == 'w2'){

        this.w2 = !this.w2

      } else if (hike == 'w3'){

        this.w3 = !this.w3

      }

    }

  },
  mounted: function(){

  },

  computed: {

    dynamicSize () {

      let calcSize = Math.pow(this.zoom * 0.6, 2)

      // console.log(calcSize);

      return [calcSize, calcSize];
    },

    dynamicAnchor () {

      // console.log(this.zoom)
      return [this.iconSize / 2, this.iconSize * 1.15];
    },

    sortMarkers() {
      // console.log(this.data.slice().sort(this.compare));
      return this.$store.state.markers;
    },

    calcHeight(){

      return this.$store.state.currentHeight;
    }

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

#map{
  // height: 100%;
  width: 100%;

}

.styleheight{

  height: 500px;
}

@media screen and (max-width: 600px) {

  .styleheight{

    height: 400px;
  }



}

</style>
